/* src/app/account/account-menu/account-menu.component.scss */
.close-button > ion-icon {
  width: 24px;
  height: 24px;
}
.close-button:hover {
  opacity: 0.85;
}
.close-button:active {
  opacity: 0.7;
}
.profile-summary {
  gap: 15px;
  border-bottom: 1px solid #cbcbcb;
}
.profile-summary img {
  max-width: 44px;
  aspect-ratio: 1/1;
  border-radius: 1000px;
  border: 2px solid #cbcbcb;
}
.all-borders {
  border: 1px solid #cbcbcb;
}
.text {
  color: #949494;
}
.menu-options {
  gap: 15px;
  padding: 0;
}
.menu-options .menu-option {
  padding: 10px 30px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.menu-options .menu-option ion-icon {
  width: 24px;
  height: 24px;
}
.menu-options .menu-option span {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.menu-options .menu-option.bg-hover:hover {
  background-color: #f6f6f6;
}
.op-hover:hover {
  background-color: #292929;
}
ion-accordion::part(header),
ion-accordion::part(content) {
  background-color: #fafafa;
}
.expanded-options {
  gap: 15px;
  padding-top: 15px;
  padding-left: 15px;
}
.expanded-options li {
  color: #949494;
}
.logout {
  color: #eb445a;
}
.logout:hover {
  background-color: rgba(235, 68, 90, 0.1490196078) !important;
}
div[slot=header] {
  cursor: pointer;
  padding-right: 30px;
}
div[slot=header]:hover {
  background-color: #f6f6f6;
}
div[slot=header].op-hover:hover {
  background-color: #292929;
}
.arrow {
  transition: transform 0.35s ease;
  transform: rotate(0deg);
}
.arrow.rotated {
  transform: rotate(-180deg);
}
.active {
  color: #0c8ce9;
  box-shadow: inset 4px 0px 0px 0px #0c8ce9;
  background-color: rgba(67, 192, 246, 0.15);
}
.active:hover {
  box-shadow: inset 4px 0px 0px 0px #0c8ce9;
  background-color: rgba(67, 192, 246, 0.15) !important;
}
.active-accordeon-header:hover {
  box-shadow: inset 4px 0px 0px 0px #0c8ce9;
  background-color: transparent !important;
}
.selected-option {
  color: #43c0f6 !important;
}
.left-menu {
  height: 100%;
  padding: 25px 25px 62px 25px;
  background-color: #fafafa;
  overflow-y: auto;
}
.left-menu::-webkit-scrollbar {
  width: 8px;
}
.left-menu::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 4px;
}
.left-menu::-webkit-scrollbar-track {
  background-color: #333333;
}
/*# sourceMappingURL=account-menu.component-SBHDEMUA.css.map */
